import React, { Component } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import { withCookies } from "react-cookie";
import { Container } from "semantic-ui-react";
import moment from "moment";
import { AppContext } from "./utils/context";
import { privateRoutes } from "./utils/routes";
import jwt from "./utils/jwt";
import request from "./utils/request";

import TopNav from "./components/TopNav";
import SideNav from "./components/SideNav";
import Login from "./pages/Login";
import JackpotKiosk from "./pages/JackpotKiosk";
import { apiUrl, loc } from './utils/constants';

class App extends Component {
  _mounted = false;
  state = {
    showSidebar: true,
    user: {
      email: "",
      fax_number: "",
      first_name: "",
      id: "",
      last_name: "",
      nonprofit_id: "",
      role: "",
      superadmin: "",
      username: ""
    },
    config: AppContext._currentValue.config
  };
  componentDidMount = async () => {
    await apiUrl();
    this.getConfig();
    this._mounted = true;
  };
  getConfig = async () => {
    const user = loc.pathname !== "/jackpot" ? await request.get(this, "api:/user", {}) : false;
    const config = await request.get(this, "api:/config", {});
    const settings = await request.get(this, "api:/settings/config", {});
    const language = await request.get(this, "api:/language", {});
    this.setState({
      user: user,
      config: config,
      settings: settings,
      language: language
    });
    return true;
  };
  // gets called on render
  validateToken = () => {
    const { cookies } = this.props;
    const accessToken = cookies.get("accessToken");
    // call to parseToken() in jwt
    const parsed = jwt.parseToken(accessToken);
    // check if session still active ? refresh token : return false
    if (parsed && jwt.refreshToken(accessToken)) {
      this.refreshToken();
    }
    return parsed !== false;
  };
  // gets called if accessToken expired
  refreshToken = () => {
    const { cookies } = this.props;
    // fetch a new accessToken and update using refreshToken
    return request
      .post(this, "api:/auth/refresh-token", {
        refresh_token: cookies.get("refreshToken")
      })
      .then(resp => {
        if (resp.access_token) {
          let parsed = jwt.validateToken(resp.access_token);
          if (parsed) {
            cookies.set("accessToken", resp.access_token, {
              path: "/",
              expires: moment.unix(parsed.exp).toDate()
            });
          } else {
            this.signOut();
          }
        } else {
          this.signOut();
        }
      });
  };
  signOut = () => {
    const { cookies } = this.props;
    cookies.set("accessToken", "", {
      path: "/",
      expires: moment.unix(-1).toDate()
    });
    cookies.remove("accessToken");
    this.setState(
      {
        user: {
          email: "",
          fax_number: "",
          first_name: "",
          id: "",
          last_name: "",
          nonprofit_id: "",
          role: "",
          superadmin: "",
          username: ""
        }
      }
    );
  };
  handleSidebar = () => {
    this.setState({ showSidebar: !this.state.showSidebar });
  };
  render() {
    const { user, showSidebar, settings, config } = this.state;
    const { history, cookies } = this.props;
    const loggedIn = loc.pathname !== "/jackpot" ? this.validateToken() : false;
    if (!this._mounted) return <Container fluid />;
    return (
      <AppContext.Provider value={this.state}>
        {!loggedIn ? (
          loc.pathname === "/jackpot" ? (<JackpotKiosk 
          location={loc} 
          defaultJackpotId={settings ? settings.general.default_jackpot_id : 0} />) : (
          <Login cookies={cookies} history={history} />)
        ) : (
            <Switch>
              {privateRoutes.map((route, index) => (
                <Route
                key={`route-${index}`}
                name={route.name}
                path={route.path}
                exact={route.exact}
                render={props => {
                  return (
                    <Container fluid id="wrapper">
                      <TopNav user={user} handleSidebar={this.handleSidebar} signOut={() => this.signOut()} />
                      <SideNav shown={showSidebar} location={history.location} config={config} />
                      <route.component
                        {...props}
                        route={route}
                        routes={route.routes}
                        cookies={route.cookies}
                        breadcrumbs={[]}
                      />
                    </Container>
                  )
                }}
              />
              ))}
            </Switch>
          )
        }
      </AppContext.Provider>
    );
  }
}

export default withCookies(withRouter(App));
